import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
import { HeroSection } from './HeroSection';
import { ServicesSection } from './ServicesSection';
import { GallerySection } from './GallerySection';
import { SMPGallerySection } from './SMPGallerySection';
import { HoursTable } from './HoursTable';
import { FAQSection } from './FAQSection';
import { FooterSection } from './FooterSection';
import { LanguageToggle } from './LanguageToggle';
const Divider = () => <hr className="border-t border-[#c9a84c] my-16 opacity-50" data-id="element-92" />;
const PullQuote = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="py-12 text-center px-4" data-id="element-93">
    <p className="font-['Playfair_Display'] italic text-2xl md:text-3xl text-[#c9a84c] leading-relaxed" data-id="element-94">
      "{children}"
    </p>
  </div>;
const Heading = ({
  children
}: {
  children: React.ReactNode;
}) => <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-bold mt-16 mb-8" data-id="element-95">
    {children}
  </h2>;
export function SalesLetterPage() {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-[#0a0a0a] text-[#f5f0e8] font-['Source_Sans_3'] selection:bg-[#c9a84c] selection:text-black" data-id="element-96">
      <LanguageToggle data-id="element-97" />
      <div className="pt-14 sm:pt-[80px] md:pt-[96px]" data-id="element-98">
        <HeroSection data-id="element-99" />
      </div>

      <main className="max-w-3xl mx-auto px-6 py-16 text-lg md:text-xl leading-relaxed space-y-6" data-id="element-100">
        {/* OPENING LEAD */}
        {t.openingLead.map((p, i) => <p key={i} data-id="element-101">{p}</p>)}

        <Divider data-id="element-102" />

        {/* HAIRCUT GALLERY */}
        <GallerySection data-id="element-103" />

        <Divider data-id="element-104" />

        {/* SMP BEFORE & AFTER */}
        <SMPGallerySection data-id="element-105" />

        <Divider data-id="element-106" />

        {/* WHAT A GREAT BARBER DOES */}
        <Heading data-id="element-107">{t.greatBarber.heading}</Heading>
        {t.greatBarber.paragraphs.map((p, i) => <p key={i} data-id="element-108">{p}</p>)}

        <PullQuote data-id="element-109">{t.pullQuotes.quote1}</PullQuote>

        <Divider data-id="element-110" />

        {/* WHY OLD SOLUTIONS FAIL */}
        <Heading data-id="element-111">{t.oldSolutions.heading}</Heading>
        {t.oldSolutions.paragraphs.map((p, i) => <p key={i} data-id="element-112">{p}</p>)}

        {/* VISUAL BREAK */}
        <div className="my-16" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/jQ3ad8qrbijj8RfFd5vKLP/joey_pic.png" alt={t.barberAlt} className="w-full h-auto border border-[#c9a84c]/30 shadow-2xl" data-id="element-114" />
        </div>

        <Divider data-id="element-115" />

        {/* THE CLASSIC BARBERSHOP STANDARD */}
        <Heading data-id="element-116">{t.classicStandard.heading}</Heading>
        {t.classicStandard.paragraphs.map((p, i) => <p key={i} data-id="element-117">{p}</p>)}

        <PullQuote data-id="element-118">{t.pullQuotes.quote2}</PullQuote>

        <Divider data-id="element-119" />

        {/* SERVICES SECTION */}
        <ServicesSection data-id="element-120" />

        <Divider data-id="element-121" />

        {/* LOCATION AND HOURS */}
        <HoursTable data-id="element-122" />

        <Divider data-id="element-123" />

        {/* THIS IS FOR YOU IF... */}
        <div className="bg-[#111111] p-8 md:p-12 border border-[#c9a84c]/20 my-12" data-id="element-124">
          <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl text-white mb-6" data-id="element-125">
            {t.forYou.heading}
          </h3>
          <ul className="space-y-4" data-id="element-126">
            {t.forYou.items.map((item, i) => <li key={i} className="flex items-start" data-id="element-127">
                <span className="text-[#c9a84c] mr-3 font-bold" data-id="element-128">-</span>
                <span data-id="element-129">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* THIS IS NOT FOR YOU IF... */}
        <div className="bg-[#0a0a0a] p-8 md:p-12 border border-red-900/30 my-12" data-id="element-130">
          <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl text-gray-400 mb-6" data-id="element-131">
            {t.notForYou.heading}
          </h3>
          <ul className="space-y-4 text-gray-400" data-id="element-132">
            {t.notForYou.items.map((item, i) => <li key={i} className="flex items-start" data-id="element-133">
                <span className="text-red-800 mr-3 font-bold" data-id="element-134">x</span>
                <span data-id="element-135">{item}</span>
              </li>)}
          </ul>
          <p className="mt-8 text-white font-bold italic" data-id="element-136">
            {t.notForYou.closing}
          </p>
        </div>

        <PullQuote data-id="element-137">{t.pullQuotes.quote3}</PullQuote>

        <Divider data-id="element-138" />

        {/* RISK REVERSAL */}
        <Heading data-id="element-139">{t.riskReversal.heading}</Heading>
        <p data-id="element-140">{t.riskReversal.paragraph}</p>

        <Divider data-id="element-141" />

        {/* URGENCY SECTION */}
        <Heading data-id="element-142">{t.urgency.heading}</Heading>
        {t.urgency.paragraphs.map((p, i) => <p key={i} data-id="element-143">{p}</p>)}

        <Divider data-id="element-144" />

        {/* CTA SECTION */}
        <div className="text-center my-20 bg-[#111111] p-8 md:p-16 border-2 border-[#c9a84c]" data-id="element-145">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl text-white font-bold mb-8" data-id="element-146">
            {t.cta.heading}
          </h2>

          <div className="space-y-4 mb-12 text-xl" data-id="element-147">
            <p data-id="element-148">
              <strong className="text-[#c9a84c] font-normal" data-id="element-149">
                {t.cta.callLabel}
              </strong>{' '}
              <a href="tel:3058853240" className="hover:text-[#c9a84c] transition-colors" data-id="element-150">
                (305) 885-3240
              </a>
            </p>
            <p data-id="element-151">
              <strong className="text-[#c9a84c] font-normal" data-id="element-152">
                {t.cta.walkLabel}
              </strong>{' '}
              3964 Curtiss Pkwy, Virginia Gardens, FL 33166
            </p>
            <p data-id="element-153">
              <strong className="text-[#c9a84c] font-normal" data-id="element-154">
                {t.cta.openLabel}
              </strong>{' '}
              {t.cta.openHours}
            </p>
          </div>

          <div className="space-y-2 mb-12 text-2xl font-['Playfair_Display'] italic text-[#f5f0e8]" data-id="element-155">
            <p data-id="element-156">{t.cta.closingLine1}</p>
            <p data-id="element-157">{t.cta.closingLine2}</p>
          </div>

          <a href="tel:3058853240" className="inline-block bg-[#c9a84c] text-black font-bold text-2xl py-6 px-12 rounded-sm hover:bg-white transition-colors duration-300 shadow-[0_0_30px_rgba(201,168,76,0.3)]" data-id="element-158">
            {t.cta.ctaButton}
          </a>
        </div>

        <Divider data-id="element-159" />

        {/* FAQ SECTION */}
        <FAQSection data-id="element-160" />
      </main>

      <FooterSection data-id="element-161" />
    </div>;
}